import { Card, Flex, Table, Typography } from "antd";
import type { ColumnType } from "antd/lib/table";
import { ImpressaoContainer, ImpressaoHeader } from "components/Impressao";
import type { ApiColetaItem } from "pages/coleta/types/ApiColetaItem";
import type { TApiLitragemMensal } from "pages/relatorios/api/apiRelLitragemMensal";
import { useMemo } from "react";
import { decimalFormater } from "std/format";
import { roundAbnt } from "std/math";
import styled from "styled-components";

const { Title } = Typography;

const FlexStyled = styled(Flex)`
   h5.ant-typography { 
        margin: 0px;
        font-weight: bold !important;
    }
`;

export const columns: ColumnType<ApiColetaItem>[] = [
	{
		dataIndex: ["produtor", "for_codigoindividual"],
		key: "for_codigoindividual",
		title: "Código",
		render: (for_codigoindividual) => <>{for_codigoindividual || ""}</>,
	},
	{
		dataIndex: ["produtor", "pessoa", "pes_nome_razaosocial"],
		key: "pes_nome_razaosocial",
		title: "Nome",
		render: (produtor) => <>{produtor || ""}</>,
	},
	{
		dataIndex: "clti_produto_nome",
		key: "clti_produto_nome",
		title: "Produto",
	},
	{
		dataIndex: "clti_volume",
		key: "clti_volume",
		title: "Volume",
		align: "right",
	},
];

export function TableRelLitragemMensal({ data, title }: { data: TApiLitragemMensal[] | undefined; title: string }) {
	// Soma o total de registros de coletaItens em todas as rotas
	const totalRegistrosGeral = useMemo(() => (data || []).reduce((acc, rota) => acc + (rota.coletaItens?.length || 0), 0), [data]);

	// Corrigir cálculo do totalVolumeGeral para somar todos os volumes de todos os coletaItens de todas as rotas
	const totalVolumeGeral = useMemo(
		() => (data || []).reduce((acc, rota) => acc + (rota.coletaItens?.reduce((sum, item) => sum + Number(item.clti_volume || 0), 0) || 0), 0),
		[data],
	);

	return (
		<ImpressaoContainer className="w-full mt-3" title={title}>
			<ImpressaoHeader title={title} />

			<Flex vertical={true} gap={"12px"} style={{ width: "100%" }}>
				{data &&
					data.length > 0 &&
					data.map((rota) => {
						return (
							<Card key={rota.rot_idpk}>
								<Title
									level={4}
									style={{
										margin: "0px",
										marginTop: "-8px",
										marginBottom: "8px",
									}}
								>
									{rota?.rot_idpk} - {rota?.rot_identificacao}
								</Title>

								<Flex vertical={true} gap={"12px"} style={{ width: "100%" }}>
									<Table
										rowKey="clti_produtor_idpk"
										columns={columns}
										dataSource={rota.coletaItens || []}
										pagination={false}
										size="small"
										rowClassName="zebra"
										summary={(rows) => {
											const totalVolume = roundAbnt(
												(rows || []).reduce((acc, cur) => acc + cur.clti_volume, 0),
												4,
											);

											return (
												<Table.Summary.Row>
													<Table.Summary.Cell index={0} align="left" colSpan={2}>
														<div style={{ display: "flex" }}>
															<Flex vertical={true}>
																<Title level={5}>Registros: {rows?.length || 0}</Title>
															</Flex>
														</div>
													</Table.Summary.Cell>

													<Table.Summary.Cell index={1} align="right" colSpan={2}>
														<Flex vertical={true}>
															<Title level={5} style={{ margin: "0px" }}>
																Total: {decimalFormater(totalVolume)}
															</Title>
														</Flex>
													</Table.Summary.Cell>
												</Table.Summary.Row>
											);
										}}
									/>
								</Flex>
							</Card>
						);
					})}

				{data && data.length > 1 && (
					<Flex justify="space-between" style={{ width: "100%", marginTop: "18px" }}>
						<FlexStyled gap={"12px"}>
							<Title level={4}>Total de Registros:</Title>
							<Title
								level={4}
								style={{
									margin: "0px",
								}}
							>
								{decimalFormater(totalRegistrosGeral || 0)}
							</Title>
						</FlexStyled>

						<FlexStyled gap={"12px"}>
							<Title level={4}>Quantidade Total:</Title>
							<Title level={4} style={{ margin: "0px" }}>
								{decimalFormater(totalVolumeGeral || 0)}
							</Title>
						</FlexStyled>
					</Flex>
				)}
			</Flex>
		</ImpressaoContainer>
	);
}
